import { InnerQueryExpression } from "../InnerQueryExpression";

export class SumCallExpression implements InnerQueryExpression {
    public readonly $discriminator = "SumCall";
    public readonly argument: InnerQueryExpression;

    public constructor(argument: InnerQueryExpression) {
        this.argument = argument;
    }
}
